module.exports = __webpack_public_path__ + "img/箱包1.a3b11e55.png";